import { Checkbox, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { observer } from 'mobx-react';
import React, { FC } from 'react';

type TProps = {
    onChange: () => void;
    description: string;
    disabled?: boolean;
    value: boolean;
    checked: boolean;
};

export const CheckboxBase: FC<TProps> = observer((props) => {
    return (
        <Stack alignItems={'center'} direction={'row'} gap={1}>
            {props.description && <Typography>{props.description}</Typography>}
            <Checkbox
                disabled={props.disabled}
                checked={props.checked}
                onChange={() => props.onChange()}
                value={props.value ? 'checked' : 'unchecked'}
                inputProps={{
                    'aria-label': 'primary checkbox'
                }}
            />
        </Stack>
    );
});
